var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("transition", {
    attrs: {
      name: _vm.animation
    }
  }, [_vm.currentVisible ? _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.currentMinimized,
      expression: "!currentMinimized"
    }],
    staticClass: "my-dialog__wrapper",
    style: _vm.wrapperStyle
  }, [_vm.modal ? _c("div", {
    staticClass: "my-dialog__modal"
  }) : _vm._e(), _c("MyDrag", _vm._b({
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: _vm.handleClickOutside,
      expression: "handleClickOutside"
    }],
    ref: "dialog",
    class: _vm.dialogClass,
    style: _vm.dialogStyle,
    on: {
      stop: _vm.handleDragStop,
      drag: _vm.handleDrag,
      start: _vm.handleDragStart
    },
    nativeOn: {
      mousedown: function mousedown($event) {
        return _vm.handleMousedown.apply(null, arguments);
      }
    }
  }, "MyDrag", _vm.dragOptions, false), [_c("MyResize", _vm._b({
    ref: "resize",
    on: {
      start: _vm.handleResizeStart,
      stop: _vm.handleResizeStop,
      resize: _vm.handleResize
    }
  }, "MyResize", _vm.resizeOptions, false), [_c("Panel", _vm._b({
    ref: "panel",
    attrs: {
      title: _vm.title,
      icon: _vm.iconOptions,
      width: _vm.dialogWidth,
      height: _vm.dialogHeight,
      "submit-text": _vm.submitText,
      "cancel-text": _vm.cancelText,
      "submit-loading": _vm.submitLoading,
      footer: _vm.footer,
      theme: _vm.theme,
      closable: _vm.closable,
      "before-close": _vm.beforeClose,
      maximizable: _vm.maximizable,
      maximized: _vm.currentMaximized,
      minimizable: _vm.minimizable,
      minimized: _vm.currentMinimized
    },
    on: {
      "update:maximized": function updateMaximized($event) {
        _vm.currentMaximized = $event;
      },
      "update:minimized": function updateMinimized($event) {
        _vm.currentMinimized = $event;
      },
      submit: _vm.handleSubmit,
      cancel: _vm.handleCancel,
      close: _vm.handleClose
    },
    scopedSlots: _vm._u([_vm.$slots.icon ? {
      key: "icon",
      fn: function fn() {
        return [_vm._t("icon")];
      },
      proxy: true
    } : null, _vm.$slots.title ? {
      key: "title",
      fn: function fn() {
        return [_vm._t("title")];
      },
      proxy: true
    } : null, _vm.$slots.tool ? {
      key: "tool",
      fn: function fn() {
        return [_vm._t("tool")];
      },
      proxy: true
    } : null, _vm.$slots.footer ? {
      key: "footer",
      fn: function fn() {
        return [_vm._t("footer")];
      },
      proxy: true
    } : null], null, true)
  }, "Panel", _vm.$attrs, false), [_c("MySpin", {
    ref: "mySpin",
    attrs: {
      fit: "",
      tip: _vm.loadingTip,
      loading: _vm.loading
    }
  }, [_vm.src ? _c("SrcFrame", {
    attrs: {
      src: _vm.src
    },
    on: {
      load: _vm.handleSrcLoad
    }
  }) : _vm._t("default")], 2)], 1)], 1)], 1)], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };